import { gql } from '@apollo/client';

export const LOGIN_USER = gql`
  query login($id: String!, $pw: String!, $campus_idx: Int, $ingnore_pw: String) {
    login(id: $id, pw: $pw, campus_idx: $campus_idx, ingnore_pw: $ingnore_pw) {
      accessToken
      refreshToken
      expire_at
    }
  }
`;

export const USER_ME = gql`
  query meQuery($token: String!) {
    me(token: $token) {
      id
      name
      idx
      type
      level_test
      campus_idx
      company_name
      study_access_available
      external_id
      english_name
      view_id
      unique_user_id
      campus {
        idx
        name
        external_id
        fc_company_idx
        meta_schedule
        etc
        switch_access
        manager {
          idx
        }
        company {
          idx
          name
          has_branch
          is_auto_schedule
          ai_app_id
          study_access_check
          switchCompany {
            idx
            name
          }
        }
      }
    }
  }
`;

export const GET_USERS = gql`
  query getUsers($type: String!, $class_idx: Int, $stat: String) {
    getUsers(type: $type, class_idx: $class_idx, stat: $stat) {
      idx
      id
      view_id
      name
      stat
      english_name
      school_name
      school_grade
      email
      phone
      memo
      birthday
      parent_name
      parent_phone
      address
      deleted_working_days
      working_hour
      current_salary
      date_of_entry
      resident_reg_no
      account_number
      academic_background
      marital_status
      children
      blood_type
      report_income
      special_category
      type
      campus_idx
      department
      idate
      last_login
      lexile_level
      study_access_available
      levelup_test_type
      external_id
      class_teacher {
        class {
          name
        }
      }
      class_student {
        idx
        class {
          idx
          name
          book_code
          begin_date
          idate
          book {
            book_sub {
              title
            }
          }
        }
      }
    }
  }
`;

export const GET_USERS_FOR_ADD_STUDENT_MODAL = gql`
  query getUsersForAddStudentModal($type: String!) {
    getUsers(type: $type) {
      idx
      view_id
      name
    }
  }
`;

export const GET_USERS_STUDENTS = gql`
  query getUsers($type: String!, $class_idx: Int, $stat: String) {
    getUsers(type: $type, class_idx: $class_idx, stat: $stat) {
      idx
      id
      view_id
      name
      stat
      english_name
      school_name
      school_grade
      email
      phone
      memo
      birthday
      parent_name
      parent_phone
      address
      deleted_working_days
      working_hour
      current_salary
      date_of_entry
      resident_reg_no
      account_number
      academic_background
      marital_status
      children
      blood_type
      report_income
      special_category
      type
      campus_idx
      department
      idate
      ddate
      lexile_level
      study_access_available
      levelup_test_type
      external_id
      last_login
      vacation_start_date
      class_teacher {
        class {
          name
        }
      }
      class_student {
        idx
        class {
          idx
          name
          book_code
          begin_date
          idate
          book {
            book_sub {
              title
            }
          }
        }
      }
    }
  }
`;

export const GET_STUDENT_USER = gql`
  query getUserData {
    getUserData {
      id
      view_id
      name
      idx
      type
      lexile_level
      study_access_available
      levelup_test_type
      external_id
      school_grade
      last_login
      class_student {
        idx
        class {
          idx
          name
          levelup_level
        }
      }
      campus {
        idx
        name
      }
    }
  }
`;

export const GET_STUDENT_LUPUSER = gql`
  query getUserData {
    getUserData {
      id
      view_id
      name
      idx
      type
      lexile_level
      study_access_available
      levelup_test_type
      external_id
      school_grade
      class_student {
        idx
        class {
          idx
          begin_date
          name
          levelup_level
        }
      }
      campus {
        idx
        name
      }
      user_levelup_tests {
        stat
        lexile
        level
        test_end_date
      }
    }
  }
`;

export const GET_TEACHER_USER = gql`
  query getUserData {
    getUserData {
      idx
      id
      view_id
      name
      english_name
      school_name
      school_grade
      email
      phone
      memo
      birthday
      parent_name
      parent_phone
      address
      type
      campus_idx
      department
      idate
      class_teacher {
        idx
        class {
          idx
          begin_date
          name
          levelup_level
        }
      }
      campus {
        idx
        name
      }
    }
  }
`;

export const USER_EXIST_CHECK = gql`
  query isUserId($userId: String!) {
    isUserId(userId: $userId) {
      idx
    }
  }
`;

export const GET_CAMPUS_STUDENT_USERS = gql`
  query getCampusStudentUsers($campus_idx: Int!, $class_idx: Int, $stat: String) {
    getCampusStudentUsers(campus_idx: $campus_idx, class_idx: $class_idx,stat:$stat) {
      idx
      id
      view_id
      name
      english_name
      phone
      parent_phone
      school_grade
      stat
      class_student {
        class {
          name
          idx
          book {
            book_sub {
              title
            }
          }
          book_code
        }
      }
      book_code_list {
        book {
          code
        }
        study_type
        issue_datetime
        start_datetime
        end_datetime
      }
    }
  }
`;

export const GET_STUDENT_HISTORY_LIST = gql`
  query classTeachersForStudent($student_idx: Int!) {
    classTeachersForStudent(student_idx: $student_idx) {
      idx
      class_idx
      user_idx
      begin_date
      end_date
      idate
      stat
      class {
        name
        begin_date
        end_date
        ddate
        class_teacher {
          user {
            idx
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_USER = gql`
  query getUserData($more_company_info: Boolean = false) {
    getUserData {
      idx
      id
      name
      english_name
      school_name
      school_grade
      email
      phone
      memo
      birthday
      parent_name
      parent_phone
      address
      type
      campus_idx
      department
      idate
      lexile_level
      study_access_available
      levelup_test_type
      external_id
      campus {
        idx
        fc_company_idx
        address
        address2
        postcode
        external_id
        company {
          idx
          is_auto_schedule
          name @include(if: $more_company_info)
          phone @include(if: $more_company_info)
          address @include(if: $more_company_info)
        }
      }
    }
  }
`;

export const GET_USER_INFO = gql`
  query getUserDataByIdx($idx: Int!) {
    getUserDataByIdx(idx: $idx) {
      idx
      id
      name
      english_name
      school_name
      school_grade
      email
      phone
      memo
      birthday
      parent_name
      parent_phone
      address
      type
      campus_idx
      department
      idate
      stat
      lexile_level
      study_access_available
      levelup_test_type
      external_id
    }
  }
`;

export const GET_USER_INFO_WITH_LEVELUP_TESTS = gql`
  query getUserDataByIdxWithLevelupTests($idx: Int!) {
    getUserDataByIdx(idx: $idx) {
      idx
      id
      name
      english_name
      school_name
      school_grade
      email
      phone
      memo
      birthday
      parent_name
      parent_phone
      address
      type
      campus_idx
      department
      idate
      stat
      lexile_level
      study_access_available
      levelup_test_type
      external_id
      user_levelup_tests {
        stat
        lexile
        level
        test_end_date
      }
    }
  }
`;
export const GET_USER_BY_IDX = gql`
  query getUserDataByIdx($idx: Int!) {
    getUserDataByIdx(idx: $idx) {
      idx
      id
      name
      english_name
      school_name
      school_grade
      email
      phone
      memo
      birthday
      parent_name
      parent_phone
      address
      type
      campus_idx
      department
      idate
      lexile_level
      study_access_available
      levelup_test_type
      external_id
    }
  }
`;

export const GET_EXIST_USERS = gql`
  query getExistUsers($user_ids: [String!]!) {
    getExistUsers(user_ids: $user_ids) {
      id
    }
  }
`;

export const GET_USER_SMS_ACCOUNT_INFO = gql`
  query getUserDataByIdx($idx: Int!) {
    getUserDataByIdx(idx: $idx) {
      idx
      id
      ione_sms_account_info
    }
  }
`;

export const GET_STUDENT_USERS_FOR_SMS = gql`
  query getUsers($type: String!) {
    getUsers(type: $type) {
      idx
      id
      name
      phone
      parent_phone
    }
  }
`;

export const GET_NEWSOMATIC_TOKEN = gql`
  query getNewsomaticToken($article_id: String, $assigned_idx: Int, $editionId: String) {
    getNewsomaticToken(article_id: $article_id, assigned_idx: $assigned_idx, editionId: $editionId)
  }
`;

export const GET_SCRIBO_TOKEN = gql`
  query getScriboToken {
    getScriboToken
  }
`;

export const GET_SCHEDULE_DATA = gql`
  query getScheduleData($campus_idx: Int!) {
    getScheduleData(campus_idx: $campus_idx) {
      campus_idx
      days
      start_time
      end_time
      no_of_system
      idate
    }
  }
`;

export const REFRESH_TOKEN = gql`
  query refresh($token: String!) {
    refresh(token: $token) {
      accessToken
      refreshToken
      expire_at
    }
  }
`;

export const READ_USER_SERVER_SAVED_DATA = gql`
  query readUserServerSavedData($idx: String!) {
    readUserServerSavedData(idx: $idx)
  }
`;

export const MY_MULTI_CAMPUS = gql`
  query myMultiCampusList {
    myMultiCampusList {
      id
      idx
      name
      company_name
      external_id
      ui_id
      view_id
      campus {
        name
      }
    }
  }
`;
